// 格式化文件大小
export const formatFileSize = (bytes) => {
  if (!bytes || bytes === 0) return '0 B'
  
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB']
  const i = Math.floor(Math.log(bytes) / Math.log(1024))
  
  if (i === 0) return `${bytes} ${sizes[i]}`
  
  return `${(bytes / Math.pow(1024, i)).toFixed(1)} ${sizes[i]}`
}

// 验证文件大小是否在限制内
export const isFileSizeValid = (fileSize, maxSize) => {
  return fileSize <= maxSize
}

// 获取可读的文件大小限制
export const getMaxFileSizeText = (maxBytes) => {
  return formatFileSize(maxBytes)
}